// Path: ./src/app/pages/StoreUploadedImagePage/useStoreUploadedImageTableColumns.tsx
import { GridRenderCellParams } from "@mui/x-data-grid";
import { messages } from "../../../locales/messages";
import { AllowedTableColumn } from "../../../utils/types/AllowTableTypes";
import { useTranslation } from "react-i18next";
import { GfStore } from "@swagger/typescript-fetch-goflyer";
import { makeStoreDisplayName } from "../../../utils/dtoUtil/makeStoreDisplayName";

export const useStoreUploadedImageTableColumns = () => {
  const { t } = useTranslation();
  const values: AllowedTableColumn[] = ["updatedAt", "createdAt"];

  const columns = [
    {
      field: "merchant",
      width: 200,
      headerName: `${t(messages["Merchant"]())}`,
      sortable: false,
      renderCell: (params: GridRenderCellParams<GfStore>) => {
        const storeName = makeStoreDisplayName(params.row);
        return <div title={storeName?.trim()}>{storeName}</div>;
      },
    },
    ...values.map((value) => {
      return {
        width: 200,
        field: value,
        headerName: `${t(messages[value]())}`,
        type: "dateTime",
        valueGetter: (val: GridRenderCellParams) => {
          return val && new Date(val?.row[value]);
        },
      };
    }),
  ];

  return columns;
};
